export default [{
  path: '/usuario',
  component: {
    name: 'usuarioBase',
    template: '<router-view />',
    meta: {
      resource: 'usuario',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'usuario-view',
    component: () => import('@/app/usuario/UsuarioView.vue'),
    meta: {
      resource: 'usuario',
      action: 'read',
      navActiveLink: 'visualizar',
      pageTitle: 'Usuários',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuario-view' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'usuario-novo',
    component: () => import('@/app/usuario/shared/components/cadastro/UsuarioCadastro.vue'),
    meta: {
      resource: 'usuario',
      action: 'create',
      navActiveLink: 'usuario-view',
      pageTitle: 'Novo usuário',
      breadcrumb: [
        {
          text: 'Usuários',
          to: { name: 'usuario-view' },
        },
        {
          text: 'Novo',
          to: { name: 'usuario-novo' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'usuario-editar',
    component: () => import('@/app/usuario/shared/components/cadastro/UsuarioCadastro.vue'),
    meta: {
      resource: 'usuario',
      action: 'update',
      navActiveLink: 'usuario',
      pageTitle: 'Editar usuário',
      breadcrumb: [
        {
          text: 'Usuários Internos',
          to: { name: 'usuario-view' },
        },
        {
          text: 'Editar',
          to: { name: 'usuario-editar' },
          active: true,
        },
      ],
    },
  }],
}]
